<script>
  import Login from '../modules/Login';

  export default {
    components: {Login},

    data: () => ({}),

    computed: {
      loginUrl() {
        return window.klv.loginUrl;
      },

    },

  }
</script>

<template>
  <div class="klv-login">
    <login/>
  </div>
</template>
